import React from 'react'
import Report from '../../../Components/DoctorComponents/Report/Report'
import Header from '../../../Components/DoctorComponents/Header/Header'
import Footer from '../../../Components/DoctorComponents/Footer/Footer'

const MedicalReport = () => {
    return (
        <div>
            <Header />
            <Report />
            <Footer />
        </div>
    )
}

export default MedicalReport